module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list-tile', {
    key: _vm.appointment.id,
    class: _vm.listItemColor,
    attrs: {
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit("listitem:clicked", _vm.appointment)
      }
    }
  }, [_vm._t("actions", function() {
    return [(_vm.withActions) ? _c('v-list-tile-action', [_c('appointment-action-menu', {
      attrs: {
        "appointment": _vm.appointment
      }
    })], 1) : _vm._e()]
  }), _vm._v(" "), _c('v-list-tile-content', {
    staticClass: "appointment-list-item-content"
  }, [_vm._t("title", function() {
    return [(_vm.appointment) ? _c('v-list-tile-title', [(_vm.appointment.is_online) ? _c('v-tooltip', {
      attrs: {
        "bottom": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [_c('v-icon', _vm._g({
            attrs: {
              "small": "",
              "x-small": ""
            }
          }, on), [_vm._v("\n            headset_mic\n          ")])]
        }
      }], null, false, 4011458489)
    }, [_vm._v(" "), _c('span', [_vm._v("This appointment is online")])]) : _vm._e(), _vm._v(" "), (_vm.withStatusChips) ? _c('v-chip', {
      staticClass: "v-chip--x-small",
      class: _vm.formattedStatus.theme,
      attrs: {
        "label": "",
        "dark": ""
      }
    }, [_vm._v("\n          " + _vm._s(_vm.formattedStatus.title) + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.appointment.title) ? _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.appointment.title)
      }
    }) : _c('span', {
      domProps: {
        "textContent": _vm._s(_vm.appointment.full_name)
      }
    }), _vm._v(" "), (_vm.appointment.zoom_meeting_id) ? _c('v-btn', {
      staticClass: "pa-0 ma-0",
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "href": ("https://zoom.us/meeting/" + (_vm.appointment.zoom_meeting_id)),
        "target": "_blank",
        "small": "",
        "x-small": "",
        "color": "primary",
        "flat": "",
        "text": ""
      }
    }, [_vm._v("Open in Zoom\n          "), _c('v-icon', {
      staticClass: "ml-2",
      attrs: {
        "small": ""
      }
    }, [_vm._v("open_in_new")])], 1) : _vm._e(), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "bottom": "",
        "max-width": 150
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function(ref) {
          var on = ref.on;

          return [(_vm.appointment.invoiceable) ? _c('v-chip', _vm._g({
            staticClass: "v-chip--x-small",
            attrs: {
              "color": "success",
              "outline": "",
              "outlined": "",
              "label": "",
              "dark": ""
            },
            on: {
              "click": function($event) {
                return _vm.$store.dispatch("SHOW_APPOINTMENT_DIALOG", [true, "InvoiceDetails", _vm.appointment])
              }
            }
          }, on), [_vm._v("Invoiceable")]) : _vm._e()]
        }
      }], null, false, 1874073358)
    }, [_vm._v(" "), _c('span', [_vm._v("Invoiceable is an optional manual flag that you can apply to keep\n            track of which appointments can safely be invoiced\n          ")])]), _vm._v(" "), (_vm.$vuetify.breakpoint.xs) ? _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.appointment.price)))]) : _vm._e()], 1) : _vm._e()]
  }), _vm._v(" "), _vm._t("sub-title", function() {
    return [_c('v-list-tile-sub-title', [_c('div', [_vm._v("\n        " + _vm._s(_vm.formatFromTo(_vm.appointment.start_time, _vm.appointment.end_time)) + "\n      ")])]), _vm._v(" "), (_vm.withTags && _vm.appointment.tags) ? _c('v-list-tile-sub-title', [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("tag")]), _vm._v(" " + _vm._s(_vm.appointment.tags) + "\n    ")], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-sub-title', [(_vm.appointment.product_name) ? [_vm._v("\n      " + _vm._s(_vm.appointment.product_name) + "\n      ")] : _vm._e(), _vm._v(" "), (_vm.appointment.practitioner_name) ? [_vm._v("\n      with " + _vm._s(_vm.appointment.practitioner_name) + "\n      ")] : _vm._e(), _vm._v(" "), (_vm.appointment.address_name) ? [_vm._v("@ " + _vm._s(_vm.appointment.address_name))] : _vm._e()], 2)]
  })], 2), _vm._v(" "), (_vm.withPricing) ? _c('v-list-tile-action', {
    staticClass: "hidden-xs-only"
  }, [_c('strong', {
    staticClass: "subheading"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.appointment.currency, _vm.appointment.price)))])]) : _vm._e(), _vm._v(" "), _vm._t("action", function() {
    return [(_vm.withAction) ? _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit('goto', _vm.appointment)
        }
      }
    }, [_c('v-icon', {
      staticClass: "grey--text text--lighten-1"
    }, [_vm._v("chevron_right")])], 1)], 1) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82f2e89e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/AppointmentListItem.vue
// module id = 1488
// module chunks = 9